import { useState } from "react";
import { useHistory } from "react-router-dom";
import { t } from "../../translations";

import { CircularProgress } from "@mui/material";
import {
  PaymentElement,
  useElements,
  useStripe
} from "@stripe/react-stripe-js";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useSelector } from "react-redux";
import { UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "./notification-bar";

import { createLogger } from "../../utils/logger";

const logger = createLogger("CheckoutFormGlocery");

const CheckoutFormGlocery = ({
  clear_cart,
  order_id,
  amount,
  setCheckoutPage,
  setCartPage
}) => {
  const history = useHistory();
  const stripe = useStripe();
  const elements = useElements();

  const lang = useSelector((state) => state.lang);
  const user = useSelector((state) => state.user);

  const [errorMessage, setErrorMessage] = useState(null);
  const [load, setLoad] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (elements == null) {
      return;
    }
    setLoad(true);

    // Trigger form validation and wallet collection
    const { error: submitError } = await elements.submit();
    if (submitError) {
      // Show error to your customer
      setLoad(false);
      setErrorMessage(submitError.message);
      return;
    }

    // Create the PaymentIntent and obtain clientSecret from your server endpoint
    const res = await fetch(
      `${service_api}/stripe/create-intent?amount=${parseInt(
        amount * 100
      )}&statement=${"Payment to Pani Food"}&order_id=${order_id}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // authorization: encryptData(token),
          authorization: user?.refresh_token,
          session: process.env.REACT_APP_API_KEY
        }
      }
    );

    const { client_secret: clientSecret } = await res.json();

    const { error, paymentIntent } = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      clientSecret: clientSecret,
      confirmParams: {
        return_url: `https://pani-web.randombackendservice.com/order/sucessful/complete?key=${order_id}`
      },
      redirect: "if_required"
    });

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      setLoad(false);

      setErrorMessage(error.message);
    } else if (paymentIntent && paymentIntent.status === "succeeded") {
      logger.log("Payment succeeded");
      handleSuccess(paymentIntent);
    } else {
      //   alert("hello I am executing here");
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  const handleSuccess = async (paymentIntent) => {
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: `order-glocery/confirm-order-payment`,
      data: {
        order_id,
        payment_intent: paymentIntent
      },
      token: user?.refresh_token
    };

    try {
      await MakeRequestAsync(request_details);
      clear_cart();
      setTimeout(() => {
        setLoad(false);
        return history.push("/order-glocery/sucessful/complete");
      }, 500);
    } catch (err) {
      setLoad(false);
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
      return openNotificationWithIcon(
        "error",
        t("common.we_couldnt_validate_your_order", lang)
      );
    }
  };

  return (
    <div
      style={{
        width: "100%",
        height: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <div className="payment-page-class">
        <h3
          style={{
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            fontWeight: "300",
            gap: 10,
            marginLeft: -5,
            cursor: "pointer"
          }}
          onClick={() => {
            setCheckoutPage(false);
            return setCartPage(true);
          }}
        >
          <MdOutlineArrowBackIosNew fontSize={20} color="#FF114D" />{" "}
          {t("common.back_to_cart", lang)}
        </h3>

        <p
          style={{
            textAlign: "left"
          }}
        >
          {t("commerce.payment_of_2", lang)} <b>{amount}</b>
        </p>

        <form onSubmit={handleSubmit}>
          <PaymentElement />
          <button
            type="submit"
            disabled={!stripe || !elements}
            style={{
              marginTop: 30,
              width: "100%",
              backgroundColor: "#FF114D",
              color: "#fff",
              fontSize: 16,
              fontWeight: "600"
            }}
          >
            {load && <CircularProgress size={25} />}
            {!load && t("common.pay_now_2", lang)}
          </button>
          {/* Show error message to your customers */}
          {errorMessage && <div>{errorMessage}</div>}
        </form>
      </div>
    </div>
  );
};

export default CheckoutFormGlocery;
